import Swiper from "swiper";
import { find } from "../utils/dom";


const textoAnuncio = () =>{

	const swiperTextoAnuncio = find(".swiper-texto-anuncio");
	if(!swiperTextoAnuncio) return;

	function construtorSwiper(swiper){
		const SwiperTexto = new Swiper(swiper,{
			slidesPerView: "auto",
			spaceBetween: 32,
			centerInsufficientSlides : true,
      centeredSlidesBounds : true,
			freeMode: true,
			speed: 5000,
			loop: true,
			mousewheel: false,
			simulateTouch: false,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			breakpoints:{
				767:{
					spaceBetween: 64,
				}
			}
		})
	}

	construtorSwiper(swiperTextoAnuncio);
}

export default textoAnuncio;